






import Vue from 'vue'

type Colors = 'purple' | 'red' | 'orange' | 'green'

interface Methods {
  handleClick: (e: MouseEvent) => void
}

interface Props {
  color: Colors
  iconCode: string
  lg?: boolean
  hovering?: boolean
  animation?: 'blink'
}

interface Computed {
  sizeClass: string
  colorClass: string
  hoverClass: string
  animationClass: string
  isSvgIcon: boolean
  svgIcon: string
}

export default Vue.extend<{}, Methods, Computed, Props>({
  props: {
    color: {
      required: false,
    },
    iconCode: {
      required: true,
    },
    lg: {
      default: () => false,
    },
    hovering: {
      default: () => true,
    },
    animation: {
      default: () => null,
    },
  },
  methods: {
    handleClick(e: MouseEvent) {
      this.$emit('click', e)
    },
  },
  computed: {
    sizeClass() {
      return this.lg ? 'lg' : ''
    },
    colorClass() {
      switch (this.color) {
        case 'red':
          return 'red-icon'
        case 'orange':
          return 'orange-icon'
        case 'green':
          return 'green-icon'
        default:
          return 'purple-icon'
      }
    },
    hoverClass() {
      return this.hovering ? 'hovering' : ''
    },
    animationClass() {
      return this.animation || ''
    },
    isSvgIcon() {
      return !this.iconCode.startsWith('zmdi')
    },
    svgIcon() {
      return require(`@/assets/svg/${this.iconCode}.svg`)
    },
  },
})
